var _style, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path2, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path3, _g19, _g20, _g21, _g22, _path4, _g23, _g24, _g25, _path5, _g26, _g27, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyCoachConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1061.3 1061.3",
    style: {
      enableBackground: "new 0 0 1061.3 1061.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A8B3;}\n\t.st1{fill:#4F5A6E;}\n\t.st2{fill:#A7CDE1;}\n\t.st3{fill:#92959A;}\n\t.st4{fill:#9545A5;}\n\t.st5{fill:#364A5E;}\n\t.st6{fill:#7E8292;}\n\t.st7{fill:#5D6678;}\n\t.st8{fill:none;}\n\t.st9{fill:#F7FAFC;}\n\t.st10{fill:#E9F2F7;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 831,
    height: 261,
    xlinkHref: "2664E82A5EBC4700.png",
    transform: "matrix(1 0 0 1 114.82 688.2411)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M915.7,813.1l-39.6-79.8c-4.3-8.7-13.2-14.2-22.9-14.2H208.4c-9.7,0-18.6,5.5-22.9,14.2l-39.9,80.3 c30.2,41.1,66.3,76.5,106.7,105.4h0.2c-2.7-1.9-5.3-3.8-7.9-5.8h572.3C854.8,884.7,888,850.9,915.7,813.1z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.4,919c6.9,4.9,13.9,9.7,21,14.3h514.4c7.1-4.6,14.1-9.3,21-14.3c0,0,0,0,0.1-0.1c2.4-1.7,4.8-3.5,7.1-5.2 c0.2-0.1,0.3-0.2,0.5-0.4c0.1,0,0.1-0.1,0.2-0.1h0H244.5C247.1,915.2,249.8,917.1,252.4,919z"
  })), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M530.7,53c-63.9-0.1-127.1,12.6-185.9,37.5c-243.1,102.7-356.9,383-254.2,626s383,356.9,626,254.2 c176.6-74.8,291.4-247.9,291.5-439.6C1008.3,267.3,794.5,53.2,530.7,53z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M850.4,308.1v383.8c0,6.6-5.4,12-12,12H223c-6.6,0-12-5.4-12-12V308.1c0-6.6,5.3-12,11.9-12.1c0,0,0,0,0.1,0 h615.4C845.1,296,850.4,301.4,850.4,308.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.7,244.3l-19.6-4.8c-2.6-0.7-5.3,0.8-6,3.5c-0.7,2.6,0.8,5.3,3.5,6c0.1,0,0.1,0,0.2,0.1l4.5,1.1 c-39.6,15.2-72,44.8-90.6,82.9c-40.5,83-6,183.5,77,224c2.4,1.2,5.4,0.3,6.6-2.2c1.2-2.4,0.3-5.4-2.2-6.6c0,0-0.1,0-0.1-0.1 c-78.1-38.1-110.6-132.7-72.5-210.8c18.3-37.4,50.6-66.1,89.9-79.7l-2.5,7c-0.9,2.6,0.5,5.4,3,6.3c2.5,0.9,5.3-0.4,6.3-3 l5.8-16.3c0.2-0.4,0.2-0.9,0.3-1.4C228.9,247.6,227.3,245,224.7,244.3C224.7,244.3,224.7,244.3,224.7,244.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.6
    },
    width: 726,
    height: 492,
    xlinkHref: "2664E82A5EBC4714.png",
    transform: "matrix(1 0 0 1 169.82 256.2411)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M841.5,278.7H219.9c-15.2,0-27.4,12.3-27.4,27.5v387.7c0,15.2,12.3,27.4,27.4,27.5h621.7 c15.1,0,27.4-12.2,27.5-27.4c0,0,0,0,0-0.1V306.1C869,291,856.7,278.7,841.5,278.7C841.5,278.7,841.5,278.7,841.5,278.7z  M850.4,691.9c0,6.6-5.4,12-12,12H223c-6.6,0-12-5.4-12-12V308.1c0-6.6,5.3-12,11.9-12.1c0,0,0,0,0.1,0h615.4 c6.6,0,12,5.4,12,12.1L850.4,691.9z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M926.2,511.7l-5.6,0.9c27.2-30.5,42.2-70,42-110.9c0-92.4-75.1-167.5-167.5-167.5c-2.7,0-4.9,2.2-4.9,4.9 c0,2.7,2.2,4.9,4.9,4.9c0,0,0,0,0,0c86.9,0,157.5,70.7,157.5,157.6c0.2,39.7-14.8,78-41.9,107l-0.6-9.4c-0.1-2.7-2.4-4.8-5.1-4.7 s-4.8,2.4-4.7,5.1c0,0.1,0,0.1,0,0.2l1.3,20.1c0.2,2.6,2.3,4.6,4.9,4.6h0.3c0.5,0,0.9-0.1,1.3-0.2l19.5-3 c2.7-0.4,4.5-2.9,4.1-5.6S928.9,511.2,926.2,511.7L926.2,511.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.6
    },
    width: 621,
    height: 70,
    xlinkHref: "2664E82A5EBC4712.png",
    transform: "matrix(1 0 0 1 221.82 890.2411)"
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.4,919c6.9,4.9,13.9,9.7,21,14.3h514.4c7.1-4.6,14.1-9.3,21-14.3c0,0,0,0,0.1-0.1 c2.4-1.7,4.8-3.5,7.1-5.2c0.2-0.1,0.3-0.2,0.5-0.4c0.1,0,0.1-0.1,0.2-0.1h0H244.5C247.1,915.2,249.8,917.1,252.4,919z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.6
    },
    width: 819,
    height: 249,
    xlinkHref: "2664E82A5EBC4713.png",
    transform: "matrix(1 0 0 1 122.82 696.2411)"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M915.7,813.1l-39.6-79.8c-4.3-8.7-13.2-14.2-22.9-14.2H208.4c-9.7,0-18.6,5.5-22.9,14.2l-39.9,80.3 c30.2,41.1,66.3,76.5,106.7,105.4h0.2c-2.7-1.9-5.3-3.8-7.9-5.8h572.3C854.8,884.7,888,850.9,915.7,813.1z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649.7,902.2H411.8c-1.1,0-2-0.8-2-1.9c0-0.3,0.1-0.7,0.2-1l28.1-56.5c1.4-2.8,4.2-4.5,7.3-4.5h170.8 c3.1,0,5.9,1.8,7.3,4.5l28,56.5c0.5,1,0.1,2.2-0.8,2.7C650.3,902.1,650,902.2,649.7,902.2z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "204.5,776.6 197.1,791.4 864.3,791.4 857,776.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "872.5,807.8 865.2,793 196.3,793 188.9,807.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "205.3,774.9 856.2,774.9 848.8,760.1 212.7,760.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M848,758.4l-4.3-8.8c-1.1-2.2-3.3-3.5-5.7-3.5H223.5c-2.4,0-4.6,1.4-5.6,3.5l-4.4,8.8H848z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M873.3,809.5H188.1l-3.7,7.4c-1.5,3.1-0.3,6.9,2.8,8.4c0.9,0.4,1.8,0.7,2.8,0.7h681.3 c3.5,0,6.3-2.8,6.3-6.3c0-1-0.2-1.9-0.7-2.8L873.3,809.5z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.4,919c6.9,4.9,13.9,9.7,21,14.3h514.4c7.1-4.6,14.1-9.3,21-14.3c0,0,0,0,0.1-0.1 c2.4-1.7,4.8-3.5,7.1-5.2c0.2-0.1,0.3-0.2,0.5-0.4c0.1,0,0.1-0.1,0.2-0.1h0H244.5C247.1,915.2,249.8,917.1,252.4,919z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 534.3,
    y1: 461.4,
    x2: 534.3,
    y2: 707.4
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M850.4,308.1v383.8c0,6.6-5.4,12-12,12H223c-6.6,0-12-5.4-12-12V308.1c0-6.6,5.3-12,11.9-12.1c0,0,0,0,0.1,0 h615.4C845.1,296,850.4,301.4,850.4,308.1z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 347.4,
    cy: 559,
    r: 47
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M409.7,703.9v-47.4c0-27.9-22.6-50.6-50.6-50.6h-23.5c-27.9,0-50.6,22.6-50.6,50.6v47.4L409.7,703.9z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 718.7,
    cy: 559,
    r: 47
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M781,703.9v-47.4c0-27.9-22.6-50.6-50.6-50.6H707c-27.9,0-50.6,22.6-50.6,50.6v47.4H781z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 529.4,
    y: 461.4,
    className: "st5",
    width: 9.8,
    height: 246
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 439,
    height: 405,
    xlinkHref: "2664E82A5EBC470C.png",
    transform: "matrix(1 0 0 1 244.82 136.2411)"
  }), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M616.2,166.7H312.1c-20.3,0-36.8,16.5-36.8,36.8v225c0,20.3,16.5,36.8,36.8,36.8h65.3l25,41.9 c5.3,5.3,7.2,5.3,12.6,0l25-41.9h176.2c20.3,0,36.8-16.5,36.8-36.8v-225C653,183.1,636.5,166.7,616.2,166.7 C616.2,166.7,616.2,166.7,616.2,166.7z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M408.6,516c-3.1,0-6.2-1.8-9.8-5.4l-0.4-0.4l-23.9-40h-62.5c-23,0-41.7-18.7-41.7-41.7v-225 c0-23,18.7-41.7,41.7-41.7h304.1c23,0,41.7,18.7,41.7,41.7v225c0,23-18.7,41.7-41.7,41.7H442.7l-23.9,40l-0.4,0.4 C414.8,514.2,411.7,516,408.6,516z M406.2,504.1c1.3,1.3,2,1.8,2.4,2c0.4-0.2,1.1-0.7,2.4-2l26.1-43.7h179 c17.6,0,31.9-14.3,31.9-31.9v-225c0-17.6-14.3-31.9-31.9-31.9l0-4.9v4.9H312.1c-17.6,0-31.9,14.3-31.9,31.9v225 c0,17.6,14.3,31.9,31.9,31.9h68.1L406.2,504.1z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M576.7,391.4H336.2c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9h240.5c2.7,0,4.9,2.2,4.9,4.9 S579.4,391.4,576.7,391.4z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M620,323.7H336.2c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9H620c2.7,0,4.9,2.2,4.9,4.9S622.7,323.7,620,323.7z "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M620,254.8H336.2c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9H620c2.7,0,4.9,2.2,4.9,4.9S622.7,254.8,620,254.8z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 473,
    height: 406,
    xlinkHref: "2664E82A5EBC4731.png",
    transform: "matrix(1 0 0 1 350.82 97.2411)"
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M756.5,128.2H418.3c-20.3,0-36.8,16.5-36.8,36.8v225c0,20.3,16.5,36.8,36.8,36.8h243.4l25,41.9 c5.3,5.3,7.2,5.3,12.6,0l25-41.9h32.3c20.3,0,36.8-16.5,36.8-36.8V165C793.3,144.7,776.9,128.2,756.5,128.2 C756.5,128.2,756.5,128.2,756.5,128.2z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M692.9,477.6c-3.1,0-6.2-1.8-9.8-5.4l-0.4-0.4l-23.9-40H418.3c-23,0-41.7-18.7-41.7-41.7V165 c0-23,18.7-41.7,41.7-41.7h338.3c23,0,41.7,18.7,41.7,41.7v225c0,23-18.7,41.7-41.7,41.7H727l-23.9,40l-0.4,0.4 C699.1,475.8,696,477.6,692.9,477.6z M690.6,465.7c1.3,1.3,2,1.8,2.4,2c0.4-0.2,1.1-0.7,2.4-2l26.1-43.7h35.1 c17.6,0,31.9-14.3,31.9-31.9V165c0-17.6-14.3-31.9-31.9-31.9H418.3c-17.6,0-31.9,14.3-31.9,31.9v225c0,17.6,14.3,31.9,31.9,31.9 h246.2L690.6,465.7z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M656.3,245.7c3.7-1.5,10.2-10.5,16.5-2.3c2.5,3.1-10.6,11.3-10.6,11.3c-2.6,1.4-5.1,3-7.5,4.9 c-0.4,2.2-0.7,4.5-0.7,6.7c-1.5,12.7-0.8,27.7-1.5,41.2c-1.1,27-9,77.1-40.8,76c-19.1-0.7-27-22.1-25.1-36.7 c7.1-51.7,41.6-82,58.8-94.3c0.8-10.9,1.9-24.3,3-37.1c-8.6,16.1-17.6,29.2-30,28.8c-13.8-0.4-22.1-13.8-20.2-35.2 c2.2-22.1,8.6-40.8,15.3-38.2c6.4,2.2,3.4,12,3,12c0,0-5.6,20.6-5.6,31.4s0.4,21.3,6,21c14.2-0.7,26.6-27.7,33.3-45.7 c3-22.4,10.5-29.9,16.1-28.1c3.4,1.1,7.9,6,4.1,16.5c-3,11.2-12.7,44.2-13.1,57.3C657.3,238.8,657,242.3,656.3,245.7z M611.4,370 c21.3,0,25.1-35.9,26.6-42.7c4.9-20.2,4.9-40.8,6.3-61C626,280.2,600.2,306,599,341.6C598.7,348.3,596.4,370,611.4,370z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M604.5,184c-8.6,15.7-4.9,54.4-26.6,52.9c-29.6-1.9-11.8-52.1-16.6-62.1c-4.1-8.6-14.5-8.3-17.9,0.3 c-3.4,8.2-12.5,52.3-15.8,53.2c-5.3,1.4-0.4-36.3-0.4-42.3c-0.2-9.4-5.2-14.3-10.6-14.7c-9.8-0.8-13.3,8.1-14.7,12.2 c-0.9-2.1-2.1-4.1-3.5-5.9c-6.8-10.2-18.7-6.7-20.2,1.6c-1,5.7,1.6,9.6,5,8.2c0.7-0.3,4.6-4.8,5.3-5.1c2.5-1.4,9.8-2.4,3.8,33.7 l0,0c-4.5,20.9-11.1,22-11.7,27.9c-0.4,3.5,6.1,4.6,7.8,4.8c12.8,1.3,14.6-61.5,23.9-60.8c9.7,0.4-7.7,55.5,12.2,56.2 c18.7,0.4,23.3-59.5,26.3-59.1c3,0-15.3,64,24.7,65.1c29.2,0.7,31-41.7,34-47C617.1,187.7,607.8,178,604.5,184z"
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M530.7,53c-63.9-0.1-127.1,12.6-185.9,37.5c-243.1,102.7-356.9,383-254.2,626c14.8,35.1,33.4,67.6,55,97.1 l39.9-80.3c4.3-8.7,13.2-14.2,22.9-14.2h644.9c9.7,0,18.6,5.5,22.9,14.2l39.6,79.8c58.7-80.2,92.3-178.3,92.4-282 C1008.3,267.3,794.5,53.2,530.7,53z"
  }))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M970.8,716.6c24.9-58.9,37.5-121.4,37.5-185.9s-12.6-127.1-37.5-185.9c-24.1-56.9-58.5-108-102.4-151.8 c-43.9-43.9-95-78.3-151.8-102.4C657.7,65.6,595.2,53,530.7,53S403.6,65.6,344.7,90.5c-56.9,24.1-108,58.5-151.8,102.4 s-78.3,95-102.4,151.8C65.6,403.6,53,466.1,53,530.7s12.6,127.1,37.5,185.9c24.1,56.9,58.5,108,102.4,151.8 c16.2,16.2,33.5,31.2,51.6,44.8h572.3c18.1-13.6,35.4-28.6,51.6-44.8C912.3,824.5,946.7,773.4,970.8,716.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 61,
    height: 61,
    xlinkHref: "2664E82A5EBC4732.png",
    transform: "matrix(1 0 0 1 785.82 883.2411)"
  }), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M816.6,913.3c-0.2,0.1-0.3,0.2-0.5,0.4C816.3,913.6,816.4,913.5,816.6,913.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.75
    },
    width: 61,
    height: 61,
    xlinkHref: "2664E82A5EBC4733.png",
    transform: "matrix(1 0 0 1 778.82 888.2411)"
  }), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.9,919C808.9,919,808.9,919,808.9,919C808.9,919,808.9,919,808.9,919L808.9,919z"
  })))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M530.7,53c64.5,0,127.1,12.6,185.9,37.5c56.9,24.1,108,58.5,151.8,102.4c43.9,43.9,78.3,95,102.4,151.8 c24.9,58.9,37.5,121.4,37.5,185.9s-12.6,127.1-37.5,185.9c-24.1,56.9-58.5,108-102.4,151.8c-43.9,43.9-95,78.3-151.8,102.4 c-58.9,24.9-121.4,37.5-185.9,37.5s-127.1-12.6-185.9-37.5c-56.9-24.1-108-58.5-151.8-102.4c-43.9-43.9-78.3-95-102.4-151.8 C65.6,657.7,53,595.2,53,530.7s12.6-127.1,37.5-185.9c24.1-56.9,58.5-108,102.4-151.8s95-78.3,151.8-102.4 C403.6,65.6,466.1,53,530.7,53 M530.7,0C237.6,0,0,237.6,0,530.7s237.6,530.7,530.7,530.7s530.7-237.6,530.7-530.7S823.7,0,530.7,0 L530.7,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCoachConnect);
export default __webpack_public_path__ + "static/media/myCoachConnect.130c33e000b726a5104066b5b652ad5f.svg";
export { ForwardRef as ReactComponent };